import { handleApiError } from "@/lib/apiErrors";

interface HandlePostApiErrorOptions {
  label: string;
  networkMessage?: string;
  unexpectedMessage?: string;
  logResponseDetails?: boolean;
}

export const handlePostApiError = (
  error: unknown,
  {
    label,
    networkMessage = "Please check your connection",
    unexpectedMessage = "Unexpected error occurred",
    logResponseDetails = false,
  }: HandlePostApiErrorOptions,
): never => {
  return handleApiError(error, {
    defaultMessage: unexpectedMessage,
    networkMessage,
    label,
    logResponseDetails,
  });
};
